// removed by extract-text-webpack-plugin
module.exports = {"counterText":"TextArea-counterText-2z0bx"};


//////////////////
// WEBPACK FOOTER
// ./modules/issFrontend/styles/TextArea.styl
// module id = ./modules/issFrontend/styles/TextArea.styl
// module chunks = 1